import { render, staticRenderFns } from "./YDTCL.vue?vue&type=template&id=3d24af8c&scoped=true&"
import script from "./YDTCL.vue?vue&type=script&lang=js&"
export * from "./YDTCL.vue?vue&type=script&lang=js&"
import style0 from "./YDTCL.vue?vue&type=style&index=0&id=3d24af8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24af8c",
  null
  
)

export default component.exports